import styled from "styled-components";
import { BREAKPOINTS, COLORS, responsive } from "../../styles/constants.style";

export const SidebarNewWrapper = styled.div`
  position: relative;
  z-index: 6;

  .container {
    padding: 0 16px;
    margin-top: 15px;
    ${responsive.TABLET_PORTRAIT`
        height: 100vh;
        padding: 0px;
        margin: 0px;
        max-width: ${BREAKPOINTS.TABLET_PORTRAIT}
    `}
  }

  .searchbox {
    margin: 40px 0 24px 0;

    .MuiInputBase-input {
      padding-left: 0;
    }

    .MuiInputAdornment-root.MuiInputAdornment-positionStart {
      margin-right: 8px;
    }

    .MuiInputBase-root.MuiOutlinedInput-root {
      border-radius: 8px;
    }
  }

  .additional-data-title {
    color: ${COLORS.cirrus_black7};
    display: block;
    margin: 32px 0 16px 16px;
    text-transform: uppercase;
  }
`;
